/**
 * FloorX particles — same cyan "bubble" field as the hero, on EVERY section.
 * Independent of GSAP so particles always run on Shopify.
 *
 * Canvas IDs (all use hero-style fall + glow):
 *   hero-particles, story-canvas, sim-particles, commercial-particles,
 *   stats-particles, materials-particles, shop-particles
 */
(function () {
  'use strict';
  if (window.__FX_INDEX_PARTICLES__) return;
  window.__FX_INDEX_PARTICLES__ = true;

  var CANVAS_IDS = [
    'hero-particles',
    'story-canvas',
    'sim-particles',
    'commercial-particles',
    'stats-particles',
    'materials-particles',
    'shop-particles'
  ];

  function byId(id) {
    var root = document.getElementById('fx-index-clone');
    if (root) {
      var el = root.querySelector('#' + id);
      if (el) return el;
    }
    return document.getElementById(id);
  }

  function placeCanvas(canvas, z) {
    if (!canvas) return;
    canvas.style.position = 'absolute';
    canvas.style.left = '0';
    canvas.style.top = '0';
    canvas.style.right = '0';
    canvas.style.bottom = '0';
    canvas.style.width = '100%';
    canvas.style.height = '100%';
    canvas.style.zIndex = String(z || 2);
    canvas.style.pointerEvents = 'none';
    canvas.style.display = 'block';
    canvas.style.visibility = 'visible';
    canvas.style.opacity = '1';
    canvas.style.mixBlendMode = 'normal';
  }

  /**
   * Hero-identical particle field (index.html style).
   * count ~50, cyan glow, upward drift (fall through top).
   */
  function startHeroStyleField(canvasId, opts) {
    opts = opts || {};
    var canvas = byId(canvasId);
    if (!canvas || canvas.dataset.fxParticles === '1') return null;

    var ctx = canvas.getContext('2d');
    if (!ctx) return null;

    canvas.dataset.fxParticles = '1';
    var count = opts.count != null ? opts.count : 55;
    var blur = opts.blur != null ? opts.blur : 8;
    var z = opts.z != null ? opts.z : 2;
    var particles = [];
    var running = true;

    function resize() {
      placeCanvas(canvas, z);
      var parent = canvas.parentElement;
      var w = window.innerWidth;
      var h = window.innerHeight;
      if (parent) {
        var r = parent.getBoundingClientRect();
        /* sticky stages are ~100vh — use parent size when available */
        if (r.width > 2) w = Math.round(r.width);
        if (r.height > 2) h = Math.round(r.height);
        /* fallback when sticky parent collapses during measure */
        if (h < 80) h = window.innerHeight;
        if (w < 80) w = window.innerWidth;
      }
      canvas.width = Math.max(1, w);
      canvas.height = Math.max(1, h);
      canvas.style.opacity = '1';
      canvas.style.visibility = 'visible';
    }

    function Particle() {
      this.reset(true);
    }
    Particle.prototype.reset = function (randomY) {
      this.x = Math.random() * (canvas.width || 1);
      this.y = randomY ? Math.random() * (canvas.height || 1) : canvas.height + Math.random() * 20;
      this.size = Math.random() * 2.2 + 0.55;
      /* same motion as hero — rise toward top of screen */
      this.speedY = Math.random() * -0.55 - 0.18;
      this.speedX = (Math.random() - 0.5) * 0.5;
      this.opacity = Math.random() * 0.55 + 0.14;
    };
    Particle.prototype.update = function () {
      this.y += this.speedY;
      this.x += this.speedX;
      if (this.y < -6) {
        this.reset(false);
        this.y = canvas.height + 4;
      }
      if (this.x < -10) this.x = canvas.width + 4;
      if (this.x > canvas.width + 10) this.x = -4;
    };
    Particle.prototype.draw = function () {
      ctx.fillStyle = 'rgba(0, 184, 255, ' + this.opacity + ')';
      ctx.shadowBlur = blur;
      ctx.shadowColor = '#00B8FF';
      ctx.beginPath();
      ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
      ctx.fill();
    };

    resize();
    for (var i = 0; i < count; i++) particles.push(new Particle());

    function loop() {
      if (!running || !canvas.isConnected) return;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      for (var j = 0; j < particles.length; j++) {
        particles[j].update();
        particles[j].draw();
      }
      requestAnimationFrame(loop);
    }
    loop();

    function onResize() {
      resize();
    }
    window.addEventListener('resize', onResize, { passive: true });
    /* sticky / font load reflows */
    setTimeout(onResize, 120);
    setTimeout(onResize, 500);
    setTimeout(onResize, 1200);

    return {
      canvas: canvas,
      resize: onResize,
      stop: function () {
        running = false;
      }
    };
  }

  function boot() {
    if (!document.getElementById('fx-index-clone')) return;

    /*
      Own all section particles so every stage matches the hero.
      Mark boot so fx-cinematic.js does not start a second system.
    */
    if (window.__FX_PARTICLES_BOOTED__) return;
    window.__FX_PARTICLES_BOOTED__ = true;

    var systems = [];
    CANVAS_IDS.forEach(function (id) {
      try {
        var sys = startHeroStyleField(id, {
          count: id === 'hero-particles' ? 55 : 50,
          blur: id === 'story-canvas' ? 10 : 8,
          z: 2
        });
        if (sys) systems.push(sys);
      } catch (e) {
        console.warn('[FX Particles] failed', id, e);
      }
    });

    window.__FX_PARTICLE_SYSTEMS__ = systems;
    console.info('[FX Particles] hero-style field on', systems.length, 'sections');

    /* Hero fade-in (index intro feel) */
    var hero = byId('hero-particles');
    if (hero) {
      hero.style.opacity = '0.25';
      setTimeout(function () {
        if (typeof gsap !== 'undefined') {
          gsap.to(hero, { opacity: 1, duration: 1.5, ease: 'power2.out', overwrite: 'auto' });
        } else {
          hero.style.transition = 'opacity 1.5s ease';
          hero.style.opacity = '1';
        }
      }, 80);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  /* late Shopify section inject */
  setTimeout(boot, 300);
})();
